import { graphql } from '@/lib/graphql';

export const AgentWorkspaceMembershipSubscription = graphql(`
  subscription AgentWorkspaceMembership($organizationId: Uuid!, $userId: Uuid!) {
    organizationMembers(where: { organizationId: { _eq: $organizationId }, userId: { _eq: $userId } }, limit: 1) {
      id
      email
      extensionNumber
      queueMembers(orderBy: { queue: { name: ASC } }) {
        id
        isEscalation
        queue {
          id
          name
          deliveryMode
          waiting: queueEntriesAggregate(where: { status: { _eq: "waiting" } }) {
            aggregate {
              count
              min {
                enteredAt
              }
            }
          }
          ringing: queueEntriesAggregate(where: { status: { _eq: "ringing" } }) {
            aggregate {
              count
            }
          }
        }
      }
      agentStatuses {
        id
        statusName
        wrapUpEndsAt
        currentCallControlId
        currentQueueEntry {
          id
          callControlId
          agentCallControlId
          callerNumber
          calledNumber
          status
          enteredAt
          answeredAt
          sessionVariables
        }
        currentAgentCallSession {
          id
          source
          direction
          status
          callControlId
          remoteCallerName
          remoteCallerNumber
          startedAt
          answeredAt
        }
      }
      agentActivity(orderBy: { occurredAt: DESC }, limit: 20) {
        id
        eventType
        previousStatus
        newStatus
        occurredAt
      }
    }
  }
`);

export const AgentWorkspaceOrganizationSubscription = graphql(`
  subscription AgentWorkspaceOrganization($organizationId: Uuid!) {
    organizationsByPk(id: $organizationId) {
      id
      outboundCallingEnabled
      outboundCallingLocked
    }
  }
`);

export const QueueAgentsSubscription = graphql(`
  subscription QueueAgents($queueId: Uuid!) {
    queueMembers(where: { queueId: { _eq: $queueId } }, orderBy: { priority: ASC }) {
      id
      priority
      isEscalation
      member {
        id
        email
        extensionNumber
        role
        agentStatuses {
          id
          statusName
          softphoneConnected
          lastHeartbeat
        }
      }
    }
  }
`);

export const QueueCallersSubscription = graphql(`
  subscription QueueCallers($queueId: Uuid!) {
    queueEntries(
      where: { queueId: { _eq: $queueId }, status: { _eq: "waiting" } }
      orderBy: [{ priority: ASC }, { enteredAt: ASC }]
    ) {
      id
      callerNumber
      calledNumber
      priority
      enteredAt
      sessionVariables
    }
  }
`);
